import { CURRENCIES_WITH_DUAL_PRICING } from '../const';

export function isDualPricingCurrency(currency: string): boolean {
  return CURRENCIES_WITH_DUAL_PRICING.some(
    (item) => item.currency === currency,
  );
}
